"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var text_1 = __importDefault(require("@pixum/text"));
var rating_1 = __importDefault(require("@pixum/rating"));
var clsx_1 = __importDefault(require("clsx"));
require("./style.css");
var Review = function Review(_a) {
  var rating = _a.rating,
    title = _a.title,
    date = _a.date,
    comment = _a.comment;
  return react_1.default.createElement("div", {
    className: "review__container"
  }, react_1.default.createElement("div", {
    className: "review__user-container"
  }, react_1.default.createElement("div", {
    className: "review__user-icon"
  }), react_1.default.createElement("div", {
    className: "review__user-details"
  }, react_1.default.createElement(text_1.default, {
    variant: "subheadline"
  }, title), react_1.default.createElement(text_1.default, {
    variant: "caption"
  }, date))), react_1.default.createElement(rating_1.default, {
    showDescription: false,
    value: rating
  }), react_1.default.createElement(text_1.default, {
    className: (0, clsx_1.default)('review__text'),
    dangerousHTML: {
      __html: comment
    },
    tag: "p",
    variant: "subheadline"
  }));
};
exports.default = Review;